export default __webpack_public_path__ + "static/media/2-1-1.7ed8cbfa.jpg";